<template>
  <div class="show-actions-container text-right">
    <slot></slot>
    <button class="show-action-btn edit mr-1" @click="$emit('clickOnEditBtn')" v-if="editItem">
      <pencil-icon size="18"/>
    </button>
    <button class="show-action-btn delete" @click="$emit('clickOnDeleteBtn')" v-if="deleteItem">
      <trash-icon size="18"/>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ShowActions',

  props: {
    editItem: {
      type: Boolean,
      default: true
    },
    deleteItem: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/ShowActions.vue